<template>
    <div v-if="document && table" class="full-height-container p-3">

        <h2>{{headerLabel}} {{table.label}}</h2>

        <div v-for="field in table.fields">
            <label v-if="isEditable(field)" class="mt-2"><strong>{{field.name}}</strong></label>
            <form-element :table="table" :field="field" :document="document" class="mb-1"></form-element>
        </div>

        <select-parent v-if="isChild && !hasParent && parentTable" :table="parentTable" :document="document"></select-parent>

        <div class="d-flex mt-3">
            <save-button :component="{value: 'Save'}" :table="table" :document="document"></save-button>
            <back-button :component="{value: 'Cancel'}"></back-button>
        </div>
    </div>
</template>

<script>
    import TableUtil from "../../utils/TableUtil";
    import ModelService from "../../services/ModelService";
    import SelectParent from "./SelectParent.vue";
    import BackButton from "../buttons/BackButton.vue";
    import SaveButton from "../buttons/SaveButton.vue";
    import TabNavigator from "../nav/TabNavigator.vue";
    import FieldUtil from "../../utils/FieldUtil";

    export default {
        name: 'StaticFormView',
        components: {TabNavigator, SaveButton, BackButton, SelectParent},
        props: ['table_id', 'document_id'],
        data () {
            return {
                model: webase.model,
                service: new ModelService(),
                tableId: '',
                table: null,
                documentId: null,
                parentDocumentId: null,
                parentTableId: null,
                document: null,
                parentTable: null,
                parentOptions: [],
                tableUtil: new TableUtil()
            }
        },
        computed: {
            primaryField() {
                return webase.utils.table.getPrimaryField(this.parentTable)
            },
            isChild() {
                return !!this.table.parent_model_id
            },
            hasParent() {
                return !!(this.parentTableId && this.parentDocumentId)
            },
            headerLabel() {
                return this.$route.name.indexOf('new') > -1 ? 'New' : 'Edit'
            }
        },
        mounted () {
            // this.tableId = this.$route.params.table_id
            this.tableId = this.table_id
            console.log("'StaticFormView, table ID: " + this.tableId)

            if(this.$route.params.parent_document_id) {
                this.parentDocumentId = this.$route.params.parent_document_id
            }

            if(this.document_id) {
                this.documentId = this.document_id
            }

            if(this.$route.params.parent_table_id) {
                this.parentTableId = this.$route.params.parent_table_id
            }

            this.service.get(this.tableId).then((response) => {
                this.table = response
                this.initDocument()

                if(this.isChild && !this.hasParent) {
                    this.parentTable = webase.managers.app.getTable(this.table.parent_model_id)
                }

            }).catch((message) => {
                console.log('StaticFormView - error loading table')
                console.log(message)
            })
        },
        methods: {
            initDocument(){
                if( this.documentId ) {
                    this.loadData()
                }
                else {
                    let tableUtil = new TableUtil()
                    this.document = tableUtil.createRecord(this.table)

                    if(this.parentDocumentId) {
                        this.document['parent_id'] = this.parentDocumentId
                    }
                }
            },
            loadData() {
                this.service.getDocument(this.table, this.documentId).then((response) => {
                    this.document = response
                }).catch((message) => {
                    console.log('error loading table')
                    console.log(message)
                })
            },
            isEditable(field) {
                return new FieldUtil(field).editable()
            }
        }
    }
</script>

<style>

</style>
